import { useQuery } from "@tanstack/react-query";
import { fetchAvimarkCalibration } from "@common/lib/api/avimarkCalibration";
import { useAccountContext } from "@/state/providers/AccountProvider";

export const avimarkCalibrationKey = (accountId: string | undefined) =>
    ["avimark-calibration", accountId ?? ""] as const;

/** EN-1250: the hub's exam setup status (EN-1249 renders it). Polls while checking; status lives in Postgres. */
/** `watching`: the caller is waiting on a run it started, so poll regardless of the cached status (a failed
 *  refetch right after the start would otherwise leave stale non-checking data and stop polling). */
export function useAvimarkCalibration(enabled = true, watching = false) {
    const { accountData } = useAccountContext();
    return useQuery({
        queryKey: avimarkCalibrationKey(accountData?.id),
        queryFn: fetchAvimarkCalibration,
        enabled: enabled && !!accountData?.id,
        // Also poll while the latest run is checking: a clinic that is already set up reads "done" on the hub
        // while a new run is still going, and the page waits on that run.
        refetchInterval: (q) =>
            watching || q.state.data?.effectiveStatus === "checking" || q.state.data?.run?.status === "checking"
                ? 5000
                : false,
        refetchOnWindowFocus: true,
    });
}
